import React, { Fragment } from 'react';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import { List, ListItem, MenuButton, Icons } from '@silverfort/sf-components';
import { MenuItemDivider } from '../DropdownMenu/MenuItem';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import ConfirmationMessage from '../Controls/ConfirmationMessage';
import StartCaptureModal from './StartCaptureModal';
import {
    DCS_STATES,
    LAYOUT_TABS,
    LOG_LEVEL_OPTIONS,
    SYSTEM_STATUS_TABS_TYPES,
    ROLES,
    TIME_RANGE_OPTIONS
} from '@silverfort-nodelibs/common/utils/consts';
import { parseComponentVersion } from '@silverfort-nodelibs/common/utils/common';
import { downloadFile, httpGet, httpPost, isUserPermitted, updateUserToState } from '../utils';

import dcIcon from './Images/server.png';
import dcConnectedIcon from './Images/server_connected.png';
import dcDisonnectedIcon from './Images/server_disconnected.png';
import protocolConnectedIcon from './Images/protocol_connected.png';
import protocolNotConnectedIcon from './Images/protocol_notconnected.png';
import protocolErrorIcon from './Images/protocol_error.png';
import { SYSTEM_MODES, SYSTEM_MODE_HIDDEN_VIEWS } from '@silverfort-nodelibs/common/utils/system-mode-config';
import { Box, Checkbox } from '@material-ui/core';
import { Dropdown } from '@silverfort/sf-components';
import { isSystemTabHiddenBySystemMode } from '../SystemSettings/common/utils';

const getProtocolState = (dcState, protocolEnabled, protocolState) => {
    if (!dcState) {
        return (
            <Tooltip title="Not Protected" arrow={true} placement="top" classes={{ tooltip: 'generic-tooltip' }}>
                <div className="state notConnected">
                    <img src={protocolNotConnectedIcon} alt="" />
                </div>
            </Tooltip>
        );
    } else if (!protocolEnabled) {
        return (
            <Tooltip title="Disabled" arrow={true} placement="top" classes={{ tooltip: 'generic-tooltip' }}>
                <div className="state notConnected">
                    <img src={protocolNotConnectedIcon} alt="" />
                </div>
            </Tooltip>
        );
    } else if (!protocolState) {
        return (
            <Tooltip title="Not Protected" arrow={true} placement="top" classes={{ tooltip: 'generic-tooltip' }}>
                <div className="state notConnected">
                    <img src={protocolNotConnectedIcon} alt="" />
                </div>
            </Tooltip>
        );
    } else {
        return (
            <Tooltip title="Protected" arrow={true} placement="top" classes={{ tooltip: 'generic-tooltip' }}>
                <div className="state connected">
                    <img src={protocolConnectedIcon} alt="" />
                </div>
            </Tooltip>
        );
    }
};
class DCStatusRow extends React.Component {
    state = {
        IsActionSent: false,
        logLevel: this.props.data.log_level,
        SelectedMetricsDuration: TIME_RANGE_OPTIONS.LAST_HOUR.value,
        isGeneratingLog: this.props.data.isGeneratingLog,
        isGeneratingCapture: false,
        MetricsAvailable: true,
        ShowCaptureModal: false
    };
    hideNodes = isSystemTabHiddenBySystemMode(
        SYSTEM_STATUS_TABS_TYPES.NODES,
        this.props.systemMode,
        this.props.isCloudOnly
    );
    hideLogActions = SYSTEM_MODE_HIDDEN_VIEWS[LAYOUT_TABS.SYSTEM_STATUS.ID][this.props.systemMode].hideLogActions;

    async componentDidMount() {
        await updateUserToState(this);
    }

    recoverDC = async () => {
        this.setState({ IsActionSent: true });
        try {
            await httpPost('/Settings/RecoverDC', {
                dcGuid: this.props.data.guid || this.props.data.dc_guid,
                nodeID: this.props.nodeID
            });
            setTimeout(() => {
                this.setState({ IsActionSent: false });
            }, 2000);
        } catch (err) {
            this.setState({ IsActionSent: false });
            console.error(err);
        }
    };
    updateDcProtection = async () => {
        if (
            !this.props.isEditor ||
            (this.props.systemMode === SYSTEM_MODES.ON_PREM &&
                !this.props.data.is_protected &&
                !(this.props.azConfig.assignedDcs || []).includes(this.props.data.dc_guid))
        ) {
            return;
        }
        this.setState({ IsActionSent: true });
        try {
            const response = await httpPost('/Settings/UpdateDcProtection', {
                dcGuid: this.props.data.guid || this.props.data.dc_guid,
                isProtected: !this.props.data.is_protected
            });
            if (response.data.result) {
                this.props.updateDcProtection(
                    this.props.data.guid || this.props.data.dc_guid,
                    !this.props.data.is_protected
                );
            }
            setTimeout(() => {
                this.setState({ IsActionSent: false });
            }, 2000);
        } catch (err) {
            this.setState({ IsActionSent: false });
            console.error(err);
        }
    };
    updateDcLogLevel = async (e) => {
        try {
            const prevValue = this.props.data.log_level;
            this.setState({ logLevel: e.value });

            const response = await httpPost('/Settings/UpdateDcLogLevel', {
                dcGuid: this.props.data.guid || this.props.data.dc_guid,
                logLevel: e.value
            });

            if (response.data.result) {
                this.props.updateDcLogLevel(this.props.data.guid || this.props.data.dc_guid, e.value);
            } else {
                this.setState({ logLevel: prevValue });
            }
            setTimeout(() => {
                this.setState({ logLevel: null });
            }, 15000);
        } catch (err) {
            console.error(err);
        }
    };

    loadDcMetrics = async (timeRangeOption) => {
        try {
            const duration = timeRangeOption.value;
            this.setState({ MetricsLoading: true });

            const response = await httpGet(`/Settings/GetDCMetrics/${this.props.data.display_name}/${duration}`);
            this.setState({
                Metrics: response.data.Metrics,
                SelectedMetricsDuration: parseInt(duration),
                MetricsLoading: false,
                MetricsLoaded: true
            });
        } catch (err) {
            console.error(err);
            this.setState({ Metrics: [], MetricsLoading: false, MetricsLoaded: true });
        }
    };
    sendLogs = async () => {
        this.setState({ isActionSent: true, isGeneratingLog: true });
        try {
            await httpGet(`/Settings/SendLogs/${this.props.data.guid}?isDC=true`);
            setTimeout(() => {
                this.setState({ isActionSent: false });
            }, 2000);
            setTimeout(() => {
                this.setState({ isGeneratingLog: false });
            }, 15000);
        } catch (err) {
            this.setState({ isActionSent: false, isGeneratingLog: false });
            console.error(err);
        }
    };
    generateLogs = async () => {
        this.setState({ isActionSent: true, isGeneratingLog: true });
        try {
            await httpGet(
                `/Settings/GenerateDCLogs/${this.props.data.guid}${
                    this.props.data.wallId ? '/' + this.props.data.wallId : ''
                }`
            );
            setTimeout(() => {
                this.setState({ isActionSent: false });
            }, 2000);
            setTimeout(() => {
                this.setState({ isGeneratingLog: false });
            }, 15000);
        } catch (err) {
            this.setState({ isActionSent: false, isGeneratingLog: false });
            console.error(err);
        }
    };

    startCapture = async (selectedDcCaptureConfig) => {
        this.setState({ isActionSent: true, isGeneratingCapture: true, ShowCaptureModal: false });
        try {
            await httpPost(
                `/Settings/GenerateCaptureFile/${this.props.data.guid}${
                    this.props.data.wallId ? '/' + this.props.data.wallId : ''
                }`,
                { data: selectedDcCaptureConfig }
            );
            setTimeout(() => {
                this.setState({ isActionSent: false });
            }, 2000);
            setTimeout(() => {
                this.setState({ isGeneratingCapture: false });
            }, 30000);
        } catch (err) {
            this.setState({ isActionSent: false, isGeneratingCapture: false });
            console.error(err);
        }
    };

    validateLastLogsBeforeDownload = () => {
        if (moment().diff(moment(this.props.data.lastLogUpload), 'days') > this.props.logsWarningDaysDiff) {
            this.setState({ ShowDownloadLogsConfirmation: true });
        } else {
            this.downloadLogs();
        }
    };

    downloadLogs = () => {
        this.setState({ ShowDownloadLogsConfirmation: false });
        downloadFile(`/Settings/DownloadDCLogs/${this.props.data.guid}/${this.props.name}`);
    };

    downloadCapture = () => {
        downloadFile(`/Settings/DownloadDCCapture/${this.props.data.guid}/${this.props.name}`);
    };

    render() {
        const hasIncidents =
            this.props.data.status === DCS_STATES.CONNECTED_WITH_INCIDENTS ||
            this.props.data.status === DCS_STATES.DISCONNECTED_WITH_INCIDENTS;

        const kerberosState = getProtocolState(
            this.props.data.state,
            this.props.data.kerberos_enabled,
            this.props.data.kerberos_state
        );
        const ntlmState = getProtocolState(
            this.props.data.state,
            this.props.data.ntlm_enabled,
            this.props.data.ntlm_state
        );
        const ldapState = getProtocolState(
            this.props.data.state,
            this.props.data.ldap_enabled,
            this.props.data.ldap_state
        );

        let ldapsState = getProtocolState(
            this.props.data.state,
            this.props.data.ldaps_enabled,
            this.props.data.ldaps_state
        );
        if (this.props.data.state && !this.props.data.ldaps_enabled && this.props.data.ldaps_state) {
            ldapsState = (
                <Tooltip title="No Certificate" arrow={true} placement="top" classes={{ tooltip: 'generic-tooltip' }}>
                    <div className="state error">
                        <img src={protocolErrorIcon} alt="" />
                    </div>
                </Tooltip>
            );
        }

        let activeNode = 'None';
        if (this.props.data.hasActiveNode) {
            activeNode = this.props.data.name;
        }

        let castleVersion = 'None';
        if (this.props.data.castleVersion) {
            const parsedCastleVersion = parseComponentVersion(this.props.data.castleVersion);
            if (parsedCastleVersion) {
                castleVersion = parsedCastleVersion;
            }
        }

        let lastLog = 'N/A';
        if (this.props.data.lastLogUpload) {
            const lastLogTime = moment(this.props.data.lastLogUpload).local();
            if (lastLogTime.isValid()) {
                lastLog = `${lastLogTime.format('L')}, ${lastLogTime.format('LTS')}`;
            }
        }

        const isPermittedChangeLogLevel = isUserPermitted(this.state.user, 'settings', ROLES.EDITOR.value);

        const isOnPrem = this.props.systemMode === SYSTEM_MODES.ON_PREM;

        return (
            <div
                id={!this.props.HideExpender ? `dcstatus_${this.props.name}` : undefined}
                className={'serverRow dcRow' + (this.props.isHeader ? ' tableHeader' : '')}>
                <div
                    className={
                        'title' +
                        (this.props.HideExpender ? ' minimal' : '') +
                        (this.props.data.is_protected === false ? ' unprotectedDc' : '')
                    }>
                    <div className="leftSide">
                        {this.props.isHeader && (
                            <>
                                {this.props.checkAllDcs && (
                                    <Checkbox
                                        disableRipple={true}
                                        checked={this.props.isAllDcsSelected}
                                        onChange={() => this.props.checkAllDcs()}
                                        onClick={(e) => e.stopPropagation()}
                                        color="primary"
                                        style={{
                                            transform: 'scale(0.667)'
                                        }}
                                        className="pl-0"
                                    />
                                )}
                                <div className={'notification tableHeaderTitle flex'}>
                                    <div>Name</div>
                                </div>
                            </>
                        )}
                        {!this.props.isHeader && (
                            <Fragment>
                                {this.props.checkDc && (
                                    <Checkbox
                                        disableRipple={true}
                                        checked={this.props.isSelected}
                                        onChange={() => {
                                            this.props.checkDc();
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        color="primary"
                                        style={{
                                            transform: 'scale(0.667)'
                                        }}
                                        className="pl-0"
                                    />
                                )}
                                <div className="imgContainer">
                                    <img
                                        className={this.props.data.is_protected === false ? 'dcIcon' : 'shieldDcIcon'}
                                        src={
                                            this.props.data.state && this.props.data.is_protected !== false
                                                ? dcConnectedIcon
                                                : this.props.data.is_protected !== false
                                                ? dcDisonnectedIcon
                                                : dcIcon
                                        }
                                        alt=""
                                    />
                                </div>
                                <div
                                    className={'dcHeader' + (this.props.data.state ? ' connected' : '')}
                                    title={`${this.props.name} ${
                                        this.props.data.ipAddress ? '(IP: ' + this.props.data.ipAddress + ')' : ''
                                    }`}>
                                    <div className="dcName">
                                        <div>{this.props.name}</div>
                                        <span> (Domain: {this.props.data.domain_name})</span>
                                    </div>
                                    {isOnPrem &&
                                        this.props.azConfig &&
                                        !(this.props.azConfig.assignedDcs || []).includes(this.props.data.dc_guid) && (
                                            <div className="az text-red-700" title={this.props.data.az}>
                                                {'Missing Availability Zone'}
                                            </div>
                                        )}
                                    {this.props.data.az && isOnPrem && (
                                        <div className="az" title={this.props.data.az}>
                                            {this.props.data.az}
                                        </div>
                                    )}
                                </div>
                            </Fragment>
                        )}
                    </div>
                    <div className="rightSide">
                        {this.props.isHeader && (
                            <Fragment>
                                <div className={'notification tableHeaderTitle header'}>Protocols</div>
                                <div className={`notification tableHeaderTitle ${this.hideNodes ? 'medium' : 'small'}`}>
                                    {this.hideNodes ? 'AD Adapter Version' : 'Active Node'}
                                </div>
                                {!this.hideLogActions && (
                                    <div className={'notification tableHeaderTitle lastLog'}>Last Generated Log</div>
                                )}
                                {!this.hideLogActions && (
                                    <div className={'notification tableHeaderTitle logLevel'}>Log Level</div>
                                )}
                                <div className={'notification tableHeaderTitle last'}>Actions</div>
                            </Fragment>
                        )}
                        {!this.props.isHeader && (
                            <Fragment>
                                <div className="notification row">
                                    <div className="protocolName">Kerberos</div>
                                    {kerberosState}
                                </div>
                                <div className="notification row">
                                    <div className="protocolName">NTLM</div>
                                    {ntlmState}
                                </div>
                                <div className="notification row">
                                    <div className="protocolName">LDAP</div>
                                    {ldapState}
                                </div>
                                <div className="notification row">
                                    <div className="protocolName">LDAPS</div>
                                    {ldapsState}
                                </div>
                                {!this.props.HideExpender && (
                                    <div
                                        className={`notification ${this.hideNodes ? 'medium' : 'small'}`}
                                        title={this.hideNodes ? castleVersion : activeNode}>
                                        <div className="info">{this.hideNodes ? castleVersion : activeNode}</div>
                                    </div>
                                )}
                            </Fragment>
                        )}
                        {!this.hideLogActions && !this.props.HideExpender && (
                            <div className="notification lastLog" title={lastLog}>
                                {(this.state.isGeneratingLog || this.props.data.isGeneratingLog) && (
                                    <i className={'fa fa-refresh fa-spin'} aria-hidden="true"></i>
                                )}
                                <div className="info">{lastLog}</div>
                            </div>
                        )}
                        {!this.hideLogActions && !this.props.HideExpender && (
                            <div className="notification logLevel" title={'logLevel'}>
                                <Dropdown
                                    className="w-[130px] [&&]:bg-sf-white border-b border-sf-gray-500 rounded-none"
                                    items={Object.values(LOG_LEVEL_OPTIONS)
                                        .filter((v) => v.value !== LOG_LEVEL_OPTIONS.none.value)
                                        .map((option) => ({
                                            value: option.value,
                                            title: option.label,
                                            disabled: option.disabled
                                        }))}
                                    selectedItems={this.state.logLevel || this.props.data.log_level}
                                    variant="trigger"
                                    fullMenuWidth={130}
                                    disabled={!isPermittedChangeLogLevel}
                                    onChange={(value) => {
                                        if (value === LOG_LEVEL_OPTIONS.extended.value) {
                                            this.setState({ ShowExtendedDebugConfirmation: true });
                                        } else {
                                            this.updateDcLogLevel({ value });
                                        }
                                    }}
                                />
                            </div>
                        )}
                        {!this.props.HideExpender && (
                            <div
                                className="actions"
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}>
                                <Tooltip
                                    disableHoverListener={this.props.isEditor}
                                    title="No permissions"
                                    arrow={true}
                                    placement="top"
                                    classes={{ tooltip: 'generic-tooltip' }}>
                                    <Box>
                                        <MenuButton
                                            className={`nodeActionsButton left-[-80px] text-left text-white`}
                                            buttonStyle="PrimarySolid"
                                            iconRight={this.state.IsActionSent ? undefined : Icons.ChevronDown}
                                            disabled={this.state.IsActionSent || !this.props.isEditor}
                                            text={this.state.IsActionSent ? 'Sent!' : 'Actions'}
                                            id={'action-dropdown' + this.props.data.guid}
                                            content={
                                                <List>
                                                    <ListItem
                                                        title="Recover"
                                                        onClick={this.recoverDC}
                                                        disabled={
                                                            !hasIncidents ||
                                                            this.props.allDcsDuringRecover ||
                                                            !this.props.isEditor
                                                        }
                                                    />
                                                    <MenuItemDivider />
                                                    <ListItem
                                                        title="Send log"
                                                        onClick={() => {
                                                            if (
                                                                !this.props.isEditor ||
                                                                (!this.props.data.state && this.props.data.is_protected)
                                                            ) {
                                                                return;
                                                            }
                                                            this.sendLogs();
                                                        }}
                                                        disabled={
                                                            !this.props.isEditor ||
                                                            (!this.props.data.state && this.props.data.is_protected)
                                                        }
                                                    />
                                                    {!this.hideLogActions && (
                                                        <>
                                                            {isOnPrem && (
                                                                <>
                                                                    <ListItem
                                                                        title="Generate Log"
                                                                        onClick={() => {
                                                                            if (
                                                                                !this.props.isEditor ||
                                                                                (!this.props.data.state &&
                                                                                    this.props.data.is_protected)
                                                                            ) {
                                                                                return;
                                                                            }
                                                                            this.generateLogs();
                                                                        }}
                                                                        disabled={
                                                                            !this.props.isEditor ||
                                                                            (!this.props.data.state &&
                                                                                this.props.data.is_protected)
                                                                        }
                                                                    />
                                                                    <ListItem
                                                                        title="Download Log"
                                                                        onClick={this.validateLastLogsBeforeDownload}
                                                                        disabled={
                                                                            !this.props.data.lastLogUpload ||
                                                                            lastLog === 'N/A' ||
                                                                            !this.props.isEditor
                                                                        }
                                                                    />
                                                                </>
                                                            )}
                                                            <ListItem
                                                                title="Start Capture"
                                                                onClick={() => {
                                                                    if (
                                                                        !this.props.isEditor ||
                                                                        (!this.props.data.state &&
                                                                            this.props.data.is_protected) ||
                                                                        this.state.isGeneratingCapture
                                                                    ) {
                                                                        return;
                                                                    }
                                                                    this.setState({ ShowCaptureModal: true });
                                                                }}
                                                                disabled={
                                                                    !this.props.isEditor ||
                                                                    (!this.props.data.state &&
                                                                        this.props.data.is_protected) ||
                                                                    this.state.isGeneratingCapture
                                                                }
                                                            />
                                                            <ListItem
                                                                title="Download Capture"
                                                                onClick={this.downloadCapture}
                                                                disabled={
                                                                    !this.props.data.lastCaptureUpload ||
                                                                    !this.props.isEditor
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                    <MenuItemDivider />
                                                    <ListItem
                                                        title={
                                                            this.props.data.is_protected === undefined ||
                                                            this.props.data.is_protected
                                                                ? `Mark as unprotected`
                                                                : `Protect DC`
                                                        }
                                                        onClick={this.updateDcProtection}
                                                        disabled={
                                                            !this.props.isEditor ||
                                                            (isOnPrem &&
                                                                !this.props.data.is_protected &&
                                                                !(this.props.azConfig.assignedDcs || []).includes(
                                                                    this.props.data.dc_guid
                                                                ))
                                                        }
                                                    />
                                                </List>
                                            }
                                        />
                                    </Box>
                                </Tooltip>
                            </div>
                        )}
                    </div>
                </div>
                {this.state.ShowDownloadLogsConfirmation && (
                    <ConfirmationMessage
                        title={'Download log'}
                        body={`The last log was generated more than ${this.props.logsWarningDaysDiff} day${
                            this.props.logsWarningDaysDiff > 1 ? 's' : ''
                        } ago. Are you sure you want to download?`}
                        approveText={'Download Log'}
                        OnCancel={() => this.setState({ ShowDownloadLogsConfirmation: false })}
                        OnApprove={() => this.downloadLogs()}
                    />
                )}
                {this.state.ShowExtendedDebugConfirmation && (
                    <ConfirmationMessage
                        title={'Switch to extended debug'}
                        body={`Using the extended debug option may affect CPU performance. Are you sure you want to use it?`}
                        approveText={'Confirm'}
                        OnCancel={() => this.setState({ ShowExtendedDebugConfirmation: false })}
                        OnApprove={() => {
                            this.setState({ ShowExtendedDebugConfirmation: false });
                            this.updateDcLogLevel({ value: LOG_LEVEL_OPTIONS.extended.value });
                        }}
                    />
                )}
                {this.state.ShowCaptureModal && (
                    <StartCaptureModal
                        onApprove={this.startCapture}
                        onCancel={() => this.setState({ ShowCaptureModal: false })}
                        dcCaptureConfig={this.props.dcCaptureConfig}
                    />
                )}
            </div>
        );
    }
}

export default DCStatusRow;
